<template>
    <div class="row">
        <div class="col-12">
            <b-tabs content-class="mt-3">
                <b-tab title="Detalii" active>
                    <table class="table table-sm mt-5 table-borderless">
                        <tr>
                            <th>
                                Nume
                            </th>
                            <td>
                                {{profile.name}}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Email
                            </th>
                            <td>
                                {{profile.email}}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Roluri
                            </th>
                            <td>
                    <span
                            class="list-name badge badge-info mr-1"
                            v-for="role in profile.roles"
                    >
                        {{role}}
                    </span>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Creeat la
                            </th>
                            <td>
                                {{profile.created_at}}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Actualizat la
                            </th>
                            <td>
                                {{profile.updated_at}}
                            </td>
                        </tr>
                    </table>
                </b-tab>
                <b-tab title="Schimbare parola">
                    <form @submit.prevent="updateUser" class="mt-5">
                        <div class="text-danger" v-show="hasError()">
                            <strong>{{getError()}}</strong>
                        </div>
                        <div class="form-group row">
                            <div class="col-10 offset-2" v-if="hasError('oldPassword')">
                                <div class="alert alert-danger">
                                    {{getError('oldPassword')}}
                                </div>
                            </div>
                            <label
                                    for="currentPassword"
                                    class="col-2"
                                    :class="{'text-danger': hasError('oldPassword')}"
                            >
                                Parola curenta
                            </label>
                            <div class="col-10">
                                <input
                                        autocomplete="current-password"
                                        type="password"
                                        class="form-control"
                                        id="currentPassword"
                                        placeholder="Parola curenta"
                                        v-model="oldPassword"
                                >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-10 offset-2">
                                <div class="alert alert-danger" v-if="hasError('password')">
                                    {{getError('password')}}
                                </div>
                            </div>
                            <label
                                    for="password"
                                    class="col-2"
                                    :class="{'text-danger': hasError('password')}"
                            >
                                Parola noua
                            </label>
                            <div class="col-10">
                                <input
                                        autocomplete="new-password"
                                        type="password"
                                        class="form-control"
                                        id="password"
                                        placeholder="Parola noua"
                                        name="password"
                                        v-model="password"
                                >
                            </div>
                        </div>
                        <div class="form-group row">
                            <label
                                    for="passwordConfirmation"
                                    :class="{'text-danger': hasError('password_confirm')}"
                                    class="col-2"
                            >
                                Repeta parola
                            </label>
                            <div class="col-10">
                                <input
                                        autocomplete="new-password"
                                        type="password"
                                        class="form-control"
                                        id="passwordConfirmation"
                                        placeholder="Repeta parola noua"
                                        v-model="passwordConfirm"
                                >
                            </div>
                        </div>
                        <button type="submit" class="btn btn-primary">Submit</button>
                    </form>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import * as types from '../store/types'
    import ErrorPrinter from '../mixins/ErrorPrinter'

    export default {
        mixins: [ErrorPrinter],
        data: () => {
            return {
                oldPassword: null,
                password: null,
                passwordConfirm: null,
                user: {},
                errors: {}
            }
        },
        methods: {
            ...mapActions('user', [types.USER_UPDATE_PASSWORD]),
            updateUser(){
                this.errors = {}
                console.log(this.oldPassword, this.password, this.passwordConfirm)
                this[types.USER_UPDATE_PASSWORD]({
                    oldPassword: this.oldPassword,
                    password: this.password,
                    password_confirmation: this.passwordConfirm
                })
                .then(resp => {
                    console.log('done updating')
                })
                .catch(err => {
                    console.log('user password update failed. what now ?')
                    this.errors = err
                })
            }
        },
        computed: {
            ...mapState('user', ['profile'])
        }
    }
</script>

<style scoped>

</style>